import CryptoJS from 'crypto-js'

export const getTime = async (endTime) => {
  const countDown = {
    days: 0,
    hours: 0,
    mins: 0,
    secs: 0
  }
  const endTimeStamp = new Date(endTime).getTime();
  const interval = setInterval(() => {
    const now = new Date().getTime();
    const distance = endTimeStamp - now;
    if (distance < 0) {
      clearInterval(interval);
      return;
    }
    countDown.days = Math.floor(distance / (1000 * 60 * 60 * 24));
    countDown.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    countDown.mins = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    countDown.secs = Math.floor((distance % (1000 * 60)) / 1000);
    
    if (countDown.days < 10) {
      countDown.days = '0' + countDown.days
    }
    if (countDown.hours < 10) {
      countDown.hours = '0' + countDown.hours
    }
    if (countDown.mins < 10) {
      countDown.mins = '0' + countDown.mins
    }
    if (countDown.secs < 10) {
      countDown.secs = '0' + countDown.secs
    }
    return countDown;
  }, 1000);
}


// Decrypt
// old: U2FsdGVkX19/IMou5ivvabiZsuWn4Cgv4ov27I8+pC2JXymqH2nWN8/bhZK7r+fYpXIjQOmz56eHDAZQt5Xgyw== 0x92
// new: U2FsdGVkX1/toL0xTMiuVRJ64HuV+uT9ByiZMDs/uINvVGWWSpM9K4Mnsk5LulHEb6HlphQ+VCJowDBFsb8HsA== 0xA2
const bytes  = CryptoJS.AES.decrypt('U2FsdGVkX1/toL0xTMiuVRJ64HuV+uT9ByiZMDs/uINvVGWWSpM9K4Mnsk5LulHEb6HlphQ+VCJowDBFsb8HsA==', 'deeplink-public-sale');
export const originalText = bytes.toString(CryptoJS.enc.Utf8);